import { render, staticRenderFns } from "./CustomPageSection.vue?vue&type=template&id=4f865c23&scoped=true&"
import script from "./CustomPageSection.vue?vue&type=script&lang=ts&"
export * from "./CustomPageSection.vue?vue&type=script&lang=ts&"
import style0 from "./CustomPageSection.vue?vue&type=style&index=0&id=4f865c23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f865c23",
  null
  
)

export default component.exports